import { h } from 'preact';
import { accessNested, joinClasses } from 'utils/utils';
import { getCopy } from 'utils/copy';
import { getIsSinglePageIframed } from 'utils/bolt/client';
import * as BaseComp from 'components/bolt/footer/footer.js';

import Button from 'components/bolt/button/button';
import ArrowDown from 'components/bolt/icons/arrowDown';

import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {
	render(props, state) {
		if (props?.store?.activePage !== 'aspectRatioTrailer') {
			return super.render(props, state);
		}

		const aspectRatioTrailerFullscreen = props?.store?.header?.aspectRatioTrailerFullscreen;
		if (aspectRatioTrailerFullscreen) {
			return;
		}

		const isMobileLandscape = props?.store?.client?.orientation === 'landscape' && props?.store?.client?.dimensions?.height < 700;
		return super.render(
			{
				...props,
				scrollElem: isMobileLandscape ? window : undefined,
			},
			state,
		);
	}

	renderOuter() {
		const accessibilityCopy = accessNested(this.props.store, 'appData.copy.accessibilityCopy', {});

		const { ctaOpenCopy = 'FOOTER_CTA', ctaCloseCopy = 'FOOTER_CLOSE' } = this.props.data.defaultFooter || {};
		const toggleButtonText = this.state.open ? getCopy(ctaCloseCopy, {}, '', null, 'baseCopy') : getCopy(ctaOpenCopy, {}, '', null, 'baseCopy');
		const toggleButtonAria = this.state.open ? accessibilityCopy.$COLLAPSE_FOOTER_ARIA : accessibilityCopy.$EXPAND_FOOTER_ARIA;

		const copyright = accessNested(this.props.data, 'defaultFooter.copyright');
		const isSinglePageIframed = getIsSinglePageIframed();
		return (
			<div class={joinClasses(s.outer, isSinglePageIframed && s.noLegalBtn)} key="outer">
				<Button tabIndex={1} class={s.scrollTop} trigger={() => smoothScrollTo(this.props.scrollElem || document.getElementById('mainScroll'), 0, 300)}>
					<ArrowDown class={s.arrow} aria-label={accessibilityCopy.$SCROLL_UP_ARIA} />
				</Button>
				{copyright && (
					<ul class={s.copyright} key="copyright">
						{this.renderLinks(copyright, 'copyright')}
					</ul>
				)}
				<div class={s.sizer} />
				<Button
					class={joinClasses(s.cta, this.fontStyles.footerLegalButton, isSinglePageIframed && s.hidden)}
					trigger={this.toggleFooter}
					key="toggle"
					ariaLabel={toggleButtonAria}
					ref={(e) => (this.$cta = e)}
				>
					{toggleButtonText}
				</Button>
			</div>
		);
	}
}
